var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0786 8.49994V9.47493C14.0786 12.1673 11.8336 14.3499 9.06427 14.3499C6.29496 14.3499 4.04999 12.1673 4.04999 9.47493V5.89988C4.04999 4.10497 5.54664 2.6499 7.39284 2.6499C9.23904 2.6499 10.7357 4.10497 10.7357 5.89988V9.47487C10.7357 10.3723 9.98737 11.0999 9.06427 11.0999C8.14118 11.0999 7.39284 10.3723 7.39284 9.47487V6.87488",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAttach);
export default __webpack_public_path__ + "static/media/add_attach.3b217a63bc14f8be28326da907add47c.svg";
export { ForwardRef as ReactComponent };